import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import { useAppDataStore } from "@/stores/appData";   // ① importa lo store

const defaultLang = localStorage.getItem("firstLanguageLang")? localStorage.getItem("firstLanguageLang") : 'it';

const routes = [
	{
		path: "/:lang/",
		name: "Home",
		component: HomeView
	},
	{
		path: "/:lang/paths",
		name: "Paths",
		component: () => import("../views/PathsView.vue")
	},
	{
		path: "/:lang/explore",
		name: "Explore",
		component: () => import("../views/ExploreView.vue")
	},
	{
		path: "/:lang/path/:id",
		name: "Path",
		component: () => import("../views/PathView.vue")
	},
	{
		path: "/:lang/path/:id/:artworkId",
		name: "PathArtwork",
		component: () => import("../views/PathArtworkView.vue")
	},
	{
		path: "/:lang/artworks",
		name: "Artworks",
		component: () => import("../views/ArtworksView.vue")
	},
	{
		path: "/:lang/gallery/:id",
		name: "Gallery",
		component: () => import("../views/GalleryView.vue")
	},
	{
		path: "/:lang/artwork/:id",
		name: "Artwork",
		component: () => import("../views/ArtworkView.vue")
	},
	{
		path: "/:lang/tutorial",
		name: "Tutorial",
		component: () => import("../views/TutorialView.vue")
	},
	{
		path: "/",
		redirect: `/${defaultLang}` // Reindirizzamento alla lingua predefinita
	},
	{
		path: "/:pathMatch(.*)*",
		redirect: `/${defaultLang}/:pathMatch(.*)*` // Reindirizza percorsi non validi con lingua predefinita
	}
];

const router = createRouter({
	history: createWebHistory(process.env.VUE_APP_BASE_URL),
	routes,
	scrollBehavior() {
		// Scroll body
		const body = document.querySelector("body");
		if (body) {
			body.scrollTop = 0;
		}
		return { top: 0 };
	}
});

router.beforeEach((to, from, next) => {
	const store = useAppDataStore();     // ottieni l’istanza

	// Aggiungi lang mancante
	if (!to.params.lang) {
		return next({ ...to, params: { ...to.params, lang: defaultLang } });
	}

	// Cambio lingua in navigazione interna
	if (to.params.lang !== store.appData.lang && store.appData.loaded) {  // appData.loaded è nel tuo state:contentReference[oaicite:0]{index=0}:contentReference[oaicite:1]{index=1}
		store.loadLang(to.params.lang, router);  // loadLang ora spinge la rotta corretta
		return; // stop: eviti doppio next()
	}
	
	next();
});

export default router;
